define('controls/calendar2',["exports", "underscore", "backbone", "common"], function (_exports, _underscore, _backbone, _common) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a, u = !0; return { s: function s() { t = t.call(r); }, n: function n() { u = !0; var r = t.next(); return r.done ? { done: !0 } : { value: r.value, done: u = !1 }; }, e: function e(r) { o = !0, a = r; }, f: function f() { try { u || null == t.return || t.return(); } finally { if (o) throw a; } } }; }
  function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
  function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
  var STATE_RO = 0;
  var STATE_SEL_FIRST = 1;
  var STATE_SEL_LAST = 2;
  var CLASS_SEL = 'c-datepicker__day--selected';
  var CLASS_SEL_START = 'c-datepicker__day--selected-start';
  var CLASS_SEL_END = 'c-datepicker__day--selected-end';
  var CLASS_RANGE = 'c-datepicker__day--range';
  var CLASS_NA = 'c-datepicker__day--na';
  var _default = _exports.default = _backbone.View.extend({
    events: {
      'click .c-datepicker__nav--prev': '_prev',
      'click .c-datepicker__nav--next': '_next',
      'click .c-datepicker__reset': '_reset',
      'click'(ev) {
        ev.stopPropagation();
        var date = ev.target.dataset.date;
        if (date) {
          switch (this.state.get('phase')) {
            case STATE_RO:
              break;
            case STATE_SEL_FIRST:
              this.state.set({
                phase: STATE_SEL_LAST,
                first: date,
                last: null
              }, {
                input: true
              });
              this._updateRangeFull();
              break;
            case STATE_SEL_LAST:
              if (this.state.get('first') !== date) {
                this._updateRangeFull(date);
                if (!this.na) {
                  this.state.set({
                    phase: STATE_SEL_FIRST,
                    last: date
                  }, {
                    input: true
                  });
                }
              }
              break;
          }
        }
      },
      'mouseover'(ev) {
        var date = ev.target.dataset.date;
        if (!date) {
          return;
        }
        var phase = this.state.get('phase');
        if (phase !== STATE_SEL_LAST) {
          return;
        }
        this._updateRangeFull(date);
      }
    },
    initialize(options) {
      var _options$startProp, _options$endProp;
      this.startProp = (_options$startProp = options.startProp) !== null && _options$startProp !== void 0 ? _options$startProp : 'start';
      this.endProp = (_options$endProp = options.endProp) !== null && _options$endProp !== void 0 ? _options$endProp : 'end';
      this.state = new _backbone.Model({
        phase: STATE_SEL_FIRST
      });
      this.calendar = this.el.querySelector('.c-datepicker__calendar');
      this.prevBtn = this.el.querySelector('.c-datepicker__nav--prev');
      this.listenTo(this.state, 'change:last', (st, value, opts) => {
        if (opts.input && st.get('phase') === STATE_SEL_FIRST) {
          var first = st.get('first');
          var last = st.get('last');
          var date = {};
          if (last > first) {
            date.start = first;
            date.end = last;
          } else {
            date.start = last;
            date.end = first;
          }
          this.model.set('date', date);
          this.trigger('change');
          this.trigger('done');
        }
      });
      this.listenTo(this.state, 'change:month', (st, month) => {
        this.prevBtn.disabled = month === 0;
        this._render();
      });
      if (this.state.get('phase') === STATE_SEL_FIRST) {
        this.el.classList.add('c-datepicker--selectable');
      }
      if (options.cssClass) {
        this.el.classList.add(options.cssClass);
      }
    },
    init() {
      this._updateDate();
    },
    show() {
      this._updateDate();
      this._updateRangeFull();
      addEventListener('resize', this._windowResize = (0, _underscore.debounce)(this._resize.bind(this), 100), {
        passive: true
      });
      this._resize();
    },
    hide() {
      removeEventListener('resize', this._windowResize);
    },
    _getDay(date) {
      return this.calendar.querySelector(`[data-date='${date}']`);
    },
    _updateDate() {
      var date = this.model.get('date');
      if (date) {
        var thisMonth = Temporal.Now.plainDateISO().toPlainYearMonth();
        var startMonth = Temporal.PlainDate.from(date.start).toPlainYearMonth();
        this.state.set({
          phase: STATE_SEL_FIRST,
          month: startMonth.since(thisMonth).months,
          first: date.start,
          last: date.end
        });
      } else {
        this.state.set({
          phase: STATE_SEL_FIRST,
          month: 0,
          first: null,
          last: null
        });
      }
    },
    _updateRangeFull(lastNew) {
      var first = this.state.get('first');
      var last = lastNew !== null && lastNew !== void 0 ? lastNew : this.state.get('last');
      var start;
      var end;
      if (!last) {
        start = first;
      } else if (last < first) {
        start = last;
        end = first;
      } else {
        start = first;
        end = last;
      }
      this.na = false;
      var _iterator = _createForOfIteratorHelper(this.calendar.querySelectorAll('[data-date]')),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _day2 = _step.value;
          var date = _day2.dataset.date;
          if (!date) {
            continue;
          }
          var inRange = date > start && date < end;
          var inRangeClass = _day2.classList.contains(CLASS_RANGE);
          if (inRange && _day2.classList.contains(CLASS_NA)) {
            this.na = true;
            return;
          }
          if (inRange !== inRangeClass) {
            _day2.classList.toggle(CLASS_RANGE, inRange);
          }
          if (date !== start && _day2.classList.contains(CLASS_SEL_START)) {
            _day2.classList.remove(CLASS_SEL, CLASS_SEL_START);
          }
          if (date !== end && _day2.classList.contains(CLASS_SEL_END)) {
            _day2.classList.remove(CLASS_SEL, CLASS_SEL_END);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (start && start !== lastNew) {
        var day = this._getDay(start);
        if (day) {
          day.classList.add(CLASS_SEL, CLASS_SEL_START);
        }
      }
      if (end && end !== lastNew) {
        var _day = this._getDay(end);
        if (_day) {
          _day.classList.add(CLASS_SEL, CLASS_SEL_END);
        }
      }
    },
    _load(month, count) {
      return (0, _common.getJSON)(`/calendar-2/${month}?count=${count}&src=1`);
    },
    async _render() {
      var month = this.state.get('month');
      var data = await this._load(month, 2);
      this.calendar.innerHTML = data.calendar;
      this._resize();
      this._updateRangeFull();
    },
    _resize() {
      var minWidth640 = innerWidth >= 640;
      this.el.classList.toggle('c-datepicker--months-2', minWidth640);
      this.el.classList.toggle('c-datepicker--months-1', !minWidth640);
      var month2 = this.calendar.querySelector('.c-datepicker__month:last-of-type');
      if (month2) {
        month2.hidden = !minWidth640;
      }
    },
    _prev(ev) {
      ev.preventDefault();
      var month = this.state.get('month');
      if (month > 0) {
        this.state.set('month', month - 1);
      }
    },
    _next(ev) {
      ev.preventDefault();
      var month = this.state.get('month');
      this.state.set('month', month + 1);
    },
    _reset(ev) {
      ev.preventDefault();
      this.model.unset('date');
      this.trigger('change');
      this.state.set({
        phase: STATE_SEL_FIRST,
        first: null,
        last: null
      });
      this._updateRangeFull();
      this.trigger('reset');
    }
  });
});//# sourceMappingURL=calendar2.js.map
;
